import React, { useState, useEffect } from "react";
import styles from "../styles/ConversionCalculator.module.css";
import { useNavigate } from "react-router-dom"; // import useNavigate
import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator } from "react-icons/fa";
const conversionRatesold = {
  'Acres': {
    'Bigha': 0.404686,
    'Guntha': 40.4686,
    'Hectares': 0.404686,
    'Kanal': 4,
    'Katha': 6.7494,
    'Marla': 80,
    'Square Feet': 43560,
    'Square Meters': 4046.86,
    'Square Yards': 4840
  },
  'Bigha': {
    'Acres': 2.47105,
    'Guntha': 100,
    'Hectares': 1,
    'Kanal': 8.1836,
    'Katha': 16.929,
    'Marla': 197.684,
    'Square Feet': 108900,
    'Square Meters': 10033.6,
    'Square Yards': 12100
  },
  'Guntha': {
    'Acres': 0.0247105,
    'Bigha': 0.010034,
    'Hectares': 0.010034,
    'Kanal': 0.081836,
    'Katha': 0.16929,
    'Marla': 1.957,
    'Square Feet': 1089,
    'Square Meters': 100.34,
    'Square Yards': 121
  },
  'Hectares': {
    'Acres': 2.47105,
    'Bigha': 1,
    'Guntha': 100,
    'Kanal': 8.1836,
    'Katha': 16.929,
    'Marla': 197.684,
    'Square Feet': 107639,
    'Square Meters': 10000,
    'Square Yards': 11959.9
  },
  'Kanal': {
    'Acres': 0.125,
    'Bigha': 0.00506,
    'Guntha': 0.508575,
    'Hectares': 0.0505857,
    'Katha': 8.56,
    'Marla': 25,
    'Square Feet': 5445,
    'Square Meters': 505.857,
    'Square Yards': 605
  },
  'Katha': {
    'Acres': 0.016121,
    'Bigha': 0.05987,
    'Guntha': 0.06096,
    'Hectares': 0.006096,
    'Kanal': 0.049,
    'Marla': 1.165,
    'Square Feet': 655.5,
    'Square Meters': 60.96,
    'Square Yards': 72.9
  },
  'Marla': {
    'Acres': 0.00625,
    'Bigha': 0.000253,
    'Guntha': 0.0252929,
    'Hectares': 0.00252929,
    'Kanal': 0.04,
    'Katha': 0.856,
    'Square Feet': 272.25,
    'Square Meters': 25.2929,
    'Square Yards': 30.25
  },
  'Square Feet': {
    'Acres': 2.2957e-5,
    'Bigha': 1.0e-5,
    'Guntha': 0.000918273,
    'Hectares': 9.2903e-6,
    'Kanal': 7.65e-5,
    'Katha': 0.00165344,
    'Marla': 0.00138889,
    'Square Meters': 0.092903,
    'Square Yards': 0.111111
  },
  'Square Meters': {
    'Acres': 0.000247105,
    'Bigha': 0.0001,
    'Guntha': 0.00918274,
    'Hectares': 0.0001,
    'Kanal': 0.000765,
    'Katha': 0.017,
    'Marla': 0.01523,
    'Square Feet': 10.7639,
    'Square Yards': 1.19599
  },
  'Square Yards': {
    'Acres': 0.000206612,
    'Bigha': 8.36127e-5,
    'Guntha': 0.00826446,
    'Hectares': 8.36127e-5,
    'Kanal': 0.0006125,
    'Katha': 0.01452,
    'Marla': 0.0125,
    'Square Feet': 9,
    'Square Meters': 0.836127
  }
};


const conversionRates = {
  'Acres': {
    'Bigha': 0.404686,
    'Guntha': 40.4686,
    'Hectares': 0.404686,
    'Square Feet': 43560,
    'Square Meters': 4046.86,
    'Square Yards': 4840
  },
  'Bigha': {
    'Acres': 2.47105,
    'Guntha': 100,
    'Hectares': 1,
    'Square Feet': 108900,
    'Square Meters': 10033.6,
    'Square Yards': 12100
  },
  'Guntha': {
    'Acres': 0.0247105,
    'Bigha': 0.010034,
    'Hectares': 0.010034,
    'Square Feet': 1089,
    'Square Meters': 100.34,
    'Square Yards': 121
  },
  'Hectares': {
    'Acres': 2.47105,
    'Bigha': 1,
    'Guntha': 100,
    'Square Feet': 107639,
    'Square Meters': 10000,
    'Square Yards': 11959.9
  },
  'Square Feet': {
    'Acres': 2.2957e-5,
    'Bigha': 1.0e-5,
    'Guntha': 0.000918273,
    'Hectares': 9.2903e-6,
    'Square Meters': 0.092903,
    'Square Yards': 0.111111
  },
  'Square Meters': {
    'Acres': 0.000247105,
    'Bigha': 0.0001,
    'Guntha': 0.00918274,
    'Hectares': 0.0001,
    'Square Feet': 10.7639,
    'Square Yards': 1.19599
  },
  'Square Yards': {
    'Acres': 0.000206612,
    'Bigha': 8.36127e-5,
    'Guntha': 0.00826446,
    'Hectares': 8.36127e-5,
    'Square Feet': 9,
    'Square Meters': 0.836127
  }
};

const ConversionCalculator = () => {
  const [converterType, setConverterType] = useState("Area Convertor");
  const [unit, setUnit] = useState("Guntha");
  const [value, setValue] = useState("");
  const [results, setResults] = useState({});
  const navigate = useNavigate(); // initialize navigate
  // Function to handle back button
  const handleBack = () => {
    navigate(-1); // go back to previous page in history
  };



const handleConvert = (eOrValue) => {
  // If it's an event, get value from e.target.value, else use the value directly
  const val = typeof eOrValue === "object" ? parseFloat(eOrValue.target.value) : parseFloat(eOrValue);

  setValue(val || "");

  if (!val || !conversionRates[unit]) {
    setResults({});
    return;
  }

  const conversions = {};
  for (const [key, rate] of Object.entries(conversionRates[unit])) {
    conversions[key] = (val * rate).toFixed(2);
  }
  setResults(conversions);
};


  // Sync component with route
  useEffect(() => {
   
    handleConvert(value);
  }, [unit]);



  // Function to handle dropdown change and navigate
  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);

    // Map each option to a route path
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };

    if (pathMap[selected]) {
      navigate(pathMap[selected]);
    }
  };

  return (
    <div className={styles.areaConvertorCalculatorPageContainer}>
      {/* Header Section */}
      <div className={styles.areaConvertorCalculatorHeader}>
        <button
          className={styles.areaConvertorCalculatorBackButton}
          onClick={handleBack} // add click handler
        >
          <FaArrowLeft />
        </button>
        <h2 className={styles.areaConvertorCalculatorHeaderTitle}>Conversion Calculator</h2>
      </div>

      {/* Dropdown inside header */}
      <div className={styles.areaConvertorCalculatorHeaderDropdownContainer}>
        <select
          value={converterType}
          onChange={handleDropdownChange}

          className={styles.areaConvertorCalculatorHeaderDropdown}
        >
          <option>Area Convertor</option>
          <option>Built-up Area Calculator</option>
          <option>Development Charges</option>
          <option>Premium for Ancillary FSI</option>
          <option>⁠Premium for Premium FSI</option>
          <option>ULC Premium</option>

        </select>
      </div>

      {/* Main Content */}
      <div className={styles.areaConvertorCalculatorMainContainer}>
        <select
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          className={styles.areaConvertorCalculatorUnitDropdown}
        >
          <option>Guntha</option>
          <option>Acres</option>
          <option>Bigha</option>
          <option>Hectares</option>
          <option>Square Feet</option>
          <option>Square Meters</option>
          <option>Square Yards</option>
        </select>

        <input
          type="number"
          placeholder="Enter value"
          value={value}
          onChange={handleConvert}
          className={styles.areaConvertorCalculatorInputBox}
        />

        {Object.keys(results).length > 0 && (
          <div className={styles.areaConvertorCalculatorResultsContainer}>
            <h3 className={styles.areaConvertorCalculatorResultsTitle}>Conversion Results</h3>
            <ul className={styles.areaConvertorCalculatorResultsList}>
              {Object.entries(results).map(([key, val]) => (
                <li key={key}>
                  {key} : {val}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversionCalculator;
